<template>
  <div class="container page-post">
    <article class="section">
      <div class="row">
          <div class="col-md-12">

          <h4>Last updated: February 09, 2021</h4>
          
            <p class="mt-3">
                 Technologies, S.A. de C.V (“us”, “we”, or “our”) operates the https://traxporta.com website and the Traxporta mobile application (the “Service”).
            </p>
            <p class="mt-3">
                This page informs you of our policies regarding the collection, use and disclosure of Personal Information when you use our Service.
            </p>
            <p class="mt-3">
                We will not use or share your information with anyone except as described in this Privacy Policy.
            </p>
            <p class="mt-3">
                We use your Personal Information for providing and improving the Service. By using the Service, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, terms used in this Privacy Policy have the same meanings as in our Terms and Conditions.
            </p>
            <p class="mt-2">
               <strong> Information Collection And Use</strong>
            </p>
            <p class="mt-3">
                While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you. Personally identifiable information may include, but is not limited to, your email address, name, phone number, postal address, other information (“Personal Information”).
            </p>
            <p class="mt-3">
                We collect this information for the purpose of providing the Service, identifying and communicating with you, responding to your requests/inquiries, servicing your purchase orders, and improving our services.
            </p>
            <p class="mt-2">
                <strong> LOg Data </strong>
            </p>
            <p class="mt-3">
                We may also collect information that your browser sends whenever you visit our Service or when you access the Service by or through a mobile device (“Log Data”).
            </p>
            <p class="mt-3">
                This Log Data may include information such as your computer’s Internet Protocol (“IP”) address, browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages and other statistics.
            </p>
            <p class="mt-3">
                When you access the Service by or through a mobile device, this Log Data may include information such as the type of mobile device you use, your mobile device unique ID, the IP address of your mobile device, your mobile operating system, the type of mobile Internet browser you use and other statistics.
            </p>
            <p class="mt-3">
                In addition, we may use third party services such as Google Analytics that collect, monitor and analyze this type of information in order to increase our Service’s functionality. These
            </p>
            <p class="mt-3">
                third party service providers have their own privacy policies addressing how they use such information.
            </p>
            <p class="mt-3">
                Please see the section regarding Location Information below regarding the use of your location information and your options.
            </p>
            <p class="mt-3">
                <strong>Location Information</strong>
            </p>
            <p class="mt-3">
                We may use and store information about your location depending on the permissions you have set on your device. We use this information to provide features of our Service, to improve and customize our Service. You can enable or disable location services when you use our Service at anytime, through your mobile device settings.
            </p>
            <p class="mt-3">
                <strong> Cookies </strong>
            </p>
            <p class="mt-3">
                Cookies are files with a small amount of data, which may include an anonymous unique identifier. Cookies are sent to your browser from a web site and transferred to your device. We use cookies to collect information in order to improve our services for you.
            </p>
            <p class="mt-3">
                You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. The Help feature on most browsers provide information on how to accept cookies, disable cookies or to notify you when receiving a new cookie.
            </p>
            <p class="mt-3">
                If you do not accept cookies, you may not be able to use some features of our Service and we recommend that you leave them turned on.
            </p>
            <p class="mt-3">
                <strong> DoubleClick Cookie </strong>
            </p>
            <p class="mt-3">
                Google, as a third party vendor, uses cookies to serve ads on our Service. Google’s use of the DoubleClick cookie enables it and its partners to serve ads to our users based on their visit to our Service or other web sites on the Internet.

            </p>
            <p class="mt-3">
                You may opt out of the use of the DoubleClick Cookie for interest-based advertising by visiting the Google Ads Settings web page: http://www.google.com/ads/preferences/
            </p>
            <p class="mt-3">
                <strong> Behavioral Remarketing </strong>
            </p>
            <p class="mt-3">
                Traxion Technologies uses remarketing services to advertise on third party web sites to you after you visited our Service. We, and our third party vendors, use cookies to inform, optimize and serve ads based on your past visits to our Service.
            </p>
            <p class="mt-3">
                <strong> Google </strong>
            </p>
            <p class="mt-3">
                Google AdWords remarketing service is provided by Google Inc.
            </p>
            <p class="mt-3">
                You can opt-out of Google Analytics for Display Advertising and customize the Google Display Network ads by visiting the Google Ads Settings page: http://www.google.com/settings/ads
            </p>
            <p class="mt-3">
                Google also recommends installing the Google Analytics Opt-out Browser Add-on – https://tools.google.com/dlpage/gaoptout – for your web browser. Google Analytics Opt-out Browser Add-on provides visitors with the ability to prevent their data from being collected and used by Google Analytics.
            </p>
            <p class="mt-3">
                For more information on the privacy practices of Google, please visit the Google Privacy Terms web page: http://www.google.com/intl/en/policies/privacy/
            </p>
            <p class="mt-3">
                <strong>Facebook</strong>
            </p>
            <p class="mt-3">
                Facebook remarketing service is provided by Facebook Inc.

            </p>
            <p class="mt-3">
                You can learn more about interest-based advertising from Facebook by visiting this page: https://www.facebook.com/help/164968693837950

            </p>
            <p class="mt-3">
                To opt-out from Facebook’s interest-based ads follow these instructions from Facebook: https://www.facebook.com/about/ads/#568137493302217

            </p>
            <p class="mt-3">
                Facebook adheres to the Self-Regulatory Principles for Online Behavioral Advertising established by the Digital Advertising Alliance. You can also opt-out from Facebook and other participating companies through the Digital Advertising Alliance in the USA http://www.aboutads.info/choices/, the Digital Advertising Alliance of Canada in Canada http://youradchoices.ca/ or the European Interactive Digital Advertising Alliance in Europe http://www.youronlinechoices.eu/, or opt-out using your mobile device settings.

            </p>
            <p class="mt-3">
                For more information on the privacy practices of Facebook, please visit Facebook’s Data Policy: https://www.facebook.com/privacy/explanation

            </p>
            <p class="mt-3">
                <strong>Do Not Track Disclosure</strong>
            </p>
            <p class="mt-3">
                We support Do Not Track (“DNT”). Do Not Track is a preference you can set in your web browser to inform websites that you do not want to be tracked.

            </p>

            <p class="mt-3">
                You can enable or disable Do Not Track by visiting the Preferences or Settings page of your web browser.

            </p>

            <p class="mt-3">
                Service Providers

            </p>

            <p class="mt-3">
                We may employ third party companies and individuals to facilitate our Service, to provide the Service on our behalf, to perform Service-related services and/or to assist us in analyzing how our Service is used.

            </p>

            <p class="mt-3">
                These third parties have access to your Personal Information only to perform specific tasks on our behalf and are obligated not to disclose or use your information for any other purpose.

            </p>

            <p class="mt-3">
                <strong>Communications</strong>
            </p>

            <p class="mt-3">
                We may use your Personal Information to contact you with newsletters, marketing or promotional materials and other information that may be of interest to you. You may opt out of receiving any, or all, of these communications from us by following the unsubscribe link or instructions provided in any email we send.

            </p>

            <p class="mt-3">
                <strong>Compliance With Laws</strong>
            </p>

            <p class="mt-3">
                We will disclose your Personal Information where required to do so by law or subpoena or if we believe that such action is necessary to comply with the law and the reasonable requests of law enforcement or to protect the security or integrity of our Service.

            </p>

            <p class="mt-3">
                <strong> Security </strong>
            </p>
            <p class="mt-3">
                The security of your Personal Information is important to us, and we strive to implement and maintain reasonable, commercially acceptable security procedures and practices appropriate to the nature of the information we store, in order to protect it from unauthorized access, destruction, use, modification, or disclosure.

            </p>
            <p class="mt-3">
                However, please be aware that no method of transmission over the internet, or method of electronic storage is 100% secure and we are unable to guarantee the absolute security of the Personal Information we have collected from you.

            </p>
            <p class="mt-3">
                <strong> International Transfer </strong>
            </p>
            <p class="mt-3">
                Your information, including Personal Information, may be transferred to — and maintained on — computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from your jurisdiction.
            </p>
            <p class="mt-3">
                If you are located outside United States and choose to provide information to us, please note that we transfer the information, including Personal Information, to United States and process it there.

            </p>
            <p class="mt-3">
                Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.

            </p>
            <p class="mt-3">
                <strong>Links To Other Sites</strong>
            </p>
            <p class="mt-3">
                Our Service may contain links to other sites that are not operated by us. If you click on a third party link, you will be directed to that third party’s site. We strongly advise you to review the Privacy Policy of every site you visit.

            </p>
            <p class="mt-3">
                We have no control over, and assume no responsibility for the content, privacy policies or practices of any third party sites or services.

            </p>

            <p class="mt-3">
                <strong>Children’s Privacy</strong>
            </p>

            <p class="mt-3">
                Only persons age 18 or older have permission to access our Service. Our Service does not address anyone under the age of 13 (“Children”).

            </p>

            <p class="mt-3">
                We do not knowingly collect personally identifiable information from children under 13. If you are a parent or guardian and you learn that your Children have provided us with Personal Information, please contact us. If we become aware that we have collected Personal Information from a children under age 13 without verification of parental consent, we take steps to remove that information from our servers.

            </p>

            <p class="mt-3">
                <strong> Changes To This Privacy Policy </strong>
            </p>

            <p class="mt-3">
                This Privacy Policy is effective as of September 21, 2017 and will remain in effect except with respect to any changes in its provisions in the future, which will be in effect immediately after being posted on this page.

            </p>

            <p class="mt-3">
                We reserve the right to update or change our Privacy Policy at any time and you should check this Privacy Policy periodically. Your continued use of the Service after we post any modifications to the Privacy Policy on this page will constitute your acknowledgment of the modifications and your consent to abide and be bound by the modified Privacy Policy.

            </p>

            <p class="mt-3">
                If we make any material changes to this Privacy Policy, we will notify you either through the email address you have provided us, or by placing a prominent notice on our website.
            </p>
            <p class="mt-3">
                <strong> Contact Us </strong>
            </p>
            <p class="mt-3">
                If you have any questions about this Privacy Policy, please contact us.
            </p>

          </div>

      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: "Politics",
};
</script>